import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconForward: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill || '#909091';
  return (
    <Icon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 16 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.144241 5.30839C0.182236 5.36762 0.234233 5.41746 0.29604 5.45387L6.22563 9.71956C6.3282 9.7864 6.45442 9.81102 6.57607 9.78803C6.69772 9.76495 6.80467 9.69623 6.87298 9.59708C6.91954 9.52828 6.9471 9.44913 6.95289 9.36733V7.12344C6.95289 7.12344 10.9566 6.06656 15.184 10.8454C15.2644 10.935 15.3787 10.9902 15.5017 10.9988C15.6247 11.0074 15.7462 10.9687 15.8393 10.8913C15.9491 10.7991 16.0081 10.6633 15.9991 10.5237C15.7993 8.22616 13.4339 2.67386 6.96885 2.67386V0.42231C6.96065 0.302391 6.90294 0.190503 6.80849 0.111447C6.71395 0.0323844 6.59051 -0.00727484 6.46539 0.0011012C6.38003 0.006657 6.29753 0.0330671 6.22565 0.0776846L0.296053 4.34338C0.140418 4.45065 0.036516 4.61357 0.00797542 4.79518C-0.0206542 4.9769 0.0284717 5.1619 0.144241 5.30839Z"
          fill={fill}
        />
      </svg>
    </Icon>
  );
};

export default IconForward;
